export default __webpack_public_path__ + "static/media/chicagoBears@2x.38aa4be5.jpg";